<template>
  <div class="polish-bottom-content">
    <div class="container">
      <transition name="fade">
        <div v-if="history[currentStep].name === 'loan_purpose'" class="polish-bottom-content__policies">
          <a href="/terms.pdf" target="_blank">Zasady korzystania z serwisu</a>
          <span> | </span>
          <a href="/privacy-policy.pdf" target="_blank">Polityka prywatności</a>
        </div>
        <div v-else-if="history[currentStep].name === 'phone'" class="polish-bottom-content__disclaimer">
          <p>Aby ukończyć wniosek o pożyczkę i znaleźć odpowiednią ofertę, udostępniamy Twoje dane osobowe, podane w tym
            formularzu, naszym partnerom – instytucjom kredytowym i pośrednikom kredytowym (wszystkim lub tylko niektórym
            – według uznania Fininity OÜ). Pełna lista takich partnerów jest dostępna pod tym
            <a href="/partners-list.pdf" target="_blank">linkiem</a>.</p>
          <p>Administratorem Twoich danych osobowych jest Fininity OÜ. Usługi na tej stronie są świadczone przez Fininity OÜ.</p>
          <p>Ta strona internetowa jest własnością i jest obsługiwana przez Fininity OÜ. Kontakt z nami jest możliwy pod adresem e-mail: compliance@{{hostname}}</p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PlBottomContent',
  data () {
    return {
      hostname: document.location.hostname,
    }
  },
  computed: {
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep
    })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.polish-bottom-content {
  padding-top: 30px;
  margin: auto 0 -40px 0;
  color: var(--white);

  &__policies {
    font-size: 14px;

    @media (max-width: 374px) {
      font-size: 12px;
    }
  }

  &__disclaimer {
    font-size: 12px;
    opacity: 0.75;

    @media (max-width: 767px) {
      text-align: left;
    }
  }

  a {
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hardcoreComponents/PlBottomContent.vue